import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7 25V5C7 3.89543 7.89543 3 9 3H21C22.1046 3 23 3.89543 23 5V25C23 26.1046 22.1046 27 21 27H9C7.89543 27 7 26.1046 7 25Z"
            fill="#F4B67E"
            stroke="#863001"
            strokeWidth="2"
        />
        <path
            d="M17 27V17C17 15.8954 17.8954 15 19 15H25C26.1046 15 27 15.8954 27 17V27C27 28.1046 26.1046 29 25 29H19C17.8954 29 17 28.1046 17 27Z"
            fill="#B1D5F6"
            stroke="#3867A5"
            strokeWidth="2"
        />
        <path
            d="M11 11V9C11 8.44772 11.4477 8 12 8H18C18.5523 8 19 8.44772 19 9V11C19 11.5523 18.5523 12 18 12H12C11.4477 12 11 11.5523 11 11Z"
            stroke="#863001"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
